export default "__VITE_ASSET__DXbAYEf$__"